export default __webpack_public_path__ + "static/banner-delicacies-0310cf820f673cf5039adfab19caaa5d.jpg";